<template>
	<v-expansion-panel>
        <v-expansion-panel-header>
          <!-- <p class="head">Part A - Fill up Personal Details for yourself & your family members</p> -->
          <p class="head">Part A</p>
          <div
            class="sub-header d-flex align-center justify-space-between"
          >
            <p>
              Enter personal details for yourself and your family members
            </p>
            <!-- <p class="content complete">Completed</p> -->
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-row class="member-section" >
              <v-col md="6" sm="6" cols="12" v-for="(item,index) in partAdata" :key="index">
                <div class="member-top-section d-flex align-center justify-space-between">
                  <p class="member-field" :id="'member_label'+(index+1)" >Member {{index+1}}</p>
                  <p class="member-field" style="cursor:pointer" :id="'memeber_form_save_btn'+(index + 1)"  v-on:click="saveMemberDetails(item,index)" v-if="seen[index]"><img class="save-icon" src="../../assets/images/save.png">Save</p>
                  <a class="member-field" :id="'memeber_form_edit_btn'+(index + 1)" v-on:click="showHide(index,member_list)" v-if="!seen[index]">
                    <img class="edit-icon" src="../../assets/images/editIcon.png">Edit
                  </a>
                </div>
                <v-form :id="'personal_detail_form'+(index+1)"  lazy-validation>
                  <div class="d-flex select-group">
                    <div class="d-flex select-input-field">
                        <v-select
                          :name="'title'+ (index + 1)"
                          :id="'title'+ (index + 1)"
                          v-model="item.title"
                          :value="'title'+ (index + 1)"
                          :items="title_list"
                          item-value="name"
                          item-text="name"
                          placeholder="Title"
                          @change="showForm(index, $event,item.member_list)"
                          style="border:1px black !important" 
                          solo
                      ></v-select>
                    </div>
                    <div v-if="item.member_list" class="d-flex select-input-field">
                      <v-select
                        v-if="index"
                          :name="'member'+ (index + 1)"
                          :id="'member'+ (index + 1)"
                          v-model="item.member"
                          :value="'member'+ (index + 1)"
                          :items="item.member_list"
                          item-value="id"
                          item-text="name"
                          placeholder="Choose Member"
                          style="border:1px black !important" 
                          @change="showForm(index, $event,item.member_list)"
                          solo
                      ></v-select>
                      <v-select
                        v-else
                          :name="'member'+ (index + 1)"
                          :id="'member'+ (index + 1)"
                          v-model="item.member"
                          :value="'member'+ (index + 1)"
                          :items="item.member_list"
                          item-value="id"
                          item-text="name"
                          placeholder="Choose Member"
                          style="border:1px black !important" 
                          solo
                          readonly
                      ></v-select>
                      <span style="color:red; display:none;" :id="'member_err'+(index + 1)" >Choose from Dropdown!</span>
                    </div>
                 
                    <div v-else class="d-flex select-input-field">
                      <v-text-field
                        type="text"
                        outlined
                        v-model="item.member"
                        dense
                        solo
                        placeholder="Enter Member Name"
                      ></v-text-field>
                    </div>
                   </div>
                  <v-col cols="12" :id="'display_memeber_form'+(index + 1)" v-if="seen[index]">
                    <div class="row deposits-second-content">
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>GENDER</p>
                        <div>
                          <v-select
                            :name="'gender'+ (index + 1)"
                            :id="'gender'+ (index + 1)"
                            v-model="item.gender"
                            :items="gender_list"
                            placeholder="Choose Gender"
                            style="border:1px black !important" 
                            solo
                          ></v-select>
                          <span style="color:red; display:none;" :id="'gender_err'+(index + 1)">Choose from Dropdown!</span>
                        </div>
                      </div>
                      <div class="col-md-6 col-12 dob-box col">
                        <p>DATE OF BIRTH</p>
                        <div class="input-field-box">
                         <Datepicker
                          format="dd MMM, yyyy"
                          required
                          @input="ageFinding($event, index, type)"
                          :name="'dob'+ (index + 1)"
                          :id="'dob'+ (index + 1)"
                          v-model="item.dob"
                        ></Datepicker>
                        <span style="color:red; display:none;" :id="'dob_err'+(index + 1)">Select DOB!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>AGE (in complete years)</p>
                        <div class="input-field-box">
                          <v-text-field
                            type="number"
                            outlined
                            :name="'age'+ (index + 1)"
                            :id="'age'+ (index + 1)"
                            v-model="item.age"
                            dense
                            readonly
                            solo
                          ></v-text-field>
                          <span style="color:red; display:none;" :id="'age_err'+(index + 1)">Enter Age!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>OCCUPATION</p>
                        <div class="input-field-box">
                          <v-select
                            :items="occupation_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose Occupation"
                            :name="'occupation'+ (index + 1)"
                            :id="'occupation'+ (index + 1)"
                            v-model="item.occupation"
                            solo
                          ></v-select>
                          <span style="color:red; display:none;" :id="'occupation_err'+(index + 1)">Select Occupation!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>MARITAL STATUS</p>
                        <div >
                          <v-select
                            :items="marital_status_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose marital Status"
                            :name="'marital_status'+ (index + 1)"
                            :id="'marital_status'+ (index + 1)"
                            v-model="item.marital_status"
                            solo
                          ></v-select>
                          <span style="color:red; display:none;" :id="'marital_status_err'+(index + 1)">Choose From Dropdown!</span>
                        </div>
                      </div>
                      <div class="col-md-6 col-12 dob-box col" v-if="item.marital_status !== 'Single' ">
                        <p>DATE OF MARRIAGE</p>
                        <div class="input-field-box">
                         <Datepicker
                          :name="'date_of_marriage'+ (index + 1)"
                          :id="'date_of_marriage'+ (index + 1)"
                          v-model="item.date_of_marriage"
                          format="dd MMM, yyyy"
                          required
                        ></Datepicker>
                        <span style="color:red; display:none;" :id="'date_of_marriage_err'+(index + 1)">Select Date Of Marriage!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>RELIGION</p>
                        <div>
                          <div class="d-flex flex-column">
                          <v-select
                            :name="'religion'+ (index + 1)"
                            :id="'religion'+ (index + 1)"
                            v-model="item.religion"
                            :items="religion_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose Religion"
                            style="border:1px black !important" 
                            @click = "removeClass($event)"
                             density="compact"
                            solo
                          ></v-select>
                        </div>
                          <span style="color:red; display:none;" :id="'religion_err'+(index + 1)">Select Religion!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>NATIONALITY</p>
                        <div class="input-field-box">
                          <v-text-field
                            :name="'nationality'+ (index + 1)"
                            :id="'nationality'+ (index + 1)"
                            v-model="item.nationality"
                            type="text"
                            outlined
                            dense
                            solo
                          ></v-text-field>
                          <span style="color:red; display:none;" :id="'nationality_err'+(index + 1)">Enter Nationality!</span>
                        </div>
                      </div>
                       <div class="col-sm-6 col-md-6 col-12">
                        <p>PAN NO</p>
                          <v-text-field
                            v-bind:class="{'pan-numberbox': isAddClass}"
                            :name="'pan_no'+ (index + 1)"
                            :id="'pan_no'+ (index + 1)"
                            v-model="item.pan_no"
                            @input="customPanError($event,index)"
                            outlined
                            dense
                            solo
                          ></v-text-field>
                        <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" :id="'pan_err'+(index + 1)">{{panError}}</span>
                      </div>
                      
                      <div class="col-sm-6 col-md-6 col-12">
                        <p>RESIDENTIAL STATUS</p>
                        <div class="input-field-box">
                          <v-select
                            :name="'residential_status'+ (index + 1)"
                            :id="'residential_status'+ (index + 1)"
                            v-model="item.residential_status"
                            :items="residential_status_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose Residential Status"
                            style="border:1px black !important" 
                            solo
                          ></v-select>
                          <span style="color:red; display:none;" :id="'residential_status_err'+(index + 1)">Enter Residential Status!</span>
                        </div>
                      </div>
                       <div class="col-sm-6 col-md-12 col-12">
                        <p>ADDRESS</p>
                        <div class="input-field-box">
                          <v-textarea
                            :name="'address'+ (index + 1)"
                            :id="'address'+ (index + 1)"
                            v-model="item.address"
                            rows="3"
                            outlined
                            dense
                            solo
                          ></v-textarea>
                          <span style="color:red; display:none;" :id="'address_err'+(index + 1)">Enter Address!</span>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-12 col-12">
                        <p>RELATION TYPE</p>
                        <div class="input-field-box" v-if ="index == 0">
                          <v-text-field
                            :name="'relation'+ (index + 1)"
                            :id="'relation'+ (index + 1)"
                            v-model="item.relation_type"
                            type="text"
                            value = 'Self'
                            outlined
                            readonly
                            dense
                            solo
                          ></v-text-field>
                        </div>
                        <div class="input-field-box" v-else>
                          <v-select
                            :name="'relation'+ (index + 1)"
                            :id="'relation'+ (index + 1)"
                            v-model="item.relation_type"
                            :items="relation_list"
                            item-value="name"
                            item-text="name"
                            placeholder="Choose Relation Status"
                            style="border:1px black !important" 
                            solo
                          ></v-select>
                          <span style="color:red; display:none;" :id="'relation_err'+(index + 1)">Choose Relation Type!</span>
                          <a v-if="!item.member_list" style="color:#f19700; float:right;" @click="removeMember(index)">
                            <b>Remove Member</b>
                          </a>
                        </div>
                      </div>
                      
                    </div>
                  </v-col>
                </v-form>
              </v-col>
              <div class="row">
                <div class="button-group">
                  <button class="btn save-btn" style="background-color:#F19700 !important; border-color:#F19700 !important" @click="showMore()">+ MORE MEMBER</button>
                </div>
              </div>
            </v-row>  
          </div>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import axios from 'axios';
  import { Auth } from "aws-amplify";
  import moment from 'moment'
  export default {
    props: ['will_id','all_member_list','relation_list'],
    components: {
        Datepicker,
    },

    data: () => ({
      three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      update_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'update.png',
      hideShow:false,
      hideShowId:'',
      allow_user_activity:localStorage.getItem('allow_user_activity'),
	    member_list: [],
	    seen: [false,false,false,false,false,false,false],
	    item:[],
	    memberDetails: [],
	    age:'',
	    gender:[],
	    dob:'',
      title:'',
	    id:'',
	    occupation:'',
	    member: [],
	    will_creation_memeber:'',
	    religion:'',
	    marital_status:'',
	    will_creation_memeber_list:[],
	    marriage_date:'',
      address:'',
      pan_no:'',
	    nationality:'',
	    residential_status:'',
	    selectedMembers: [],
	    select: null,
	    name:'',
	    deposit:[],
	    items:[],
      panError:'',
      isAddClassServerError:false,
      isAddClass: false,
	    gender_list: ['MALE','FEMALE','TRANSGENDER'],
	    residential_status_list: [{ name: 'Resident' },{ name: 'Resident and Ordinarily Resident (ROR)'},{ name: 'Resident but Not Ordinarily Resident (RNOR)'}, { name: 'Non Resident'}],
	    items: [],
	    responses:[],
      title_list:[{name:'Mr'}, {name:'Mrs'}, {name:'Jr'}, {name:'Sr'}, {name:'Prof'}, {name:'Dr'}, {name:'Esq'},{name:'Rev'}, {name:'St'}, {name:'Hon'}],
	    marital_status_list:[{name:'Married'}, {name:'Widowed'}, {name:'Separated'}, {name:'Divorced'}, {name:'Single'}],
	    occupation_list:[{name:'Service'}, {name:'Business'}, {name:'Professional'}, {name:'Retired'}, {name:'Student'}, {name:'Agricultural Activities'}, {name:'Self Employed'}],
	    display_memeber_form1:false,
	    display_memeber_form2:false,
	    display_memeber_form3:false,
	    display_memeber_form4:false,
	    display_memeber_form5:false,
	    display_memeber_form6:false,
	    display_memeber_form7:false,
	    display_memeber_form8:false,
	    display_memeber_form9:false,
	    display_memeber_form10:false,
	    religion_list:[{name:'Hindu'}, {name:'Muslims'}, {name:'Sikh'}, {name:'Christian'},{name:'Buddhist'},{name:'Jain'},{name:'Zoroastrian'},{name:'Baha’i'},{name:'Judaism'},{name:'Atheist'}],
	    more_member_count:10,
	    more_block_cnt : 1,
	    display_more_memeber_form:false,
      cognitoDetails:{},
      partAdata:[]
    }),
    watch: {
      pan_no(val)
      {
        this.pan_no = val.toUpperCase();
        this.customPanError();
      }
    },
    mounted() {
      this.initialize();
    },
    methods: {
        customPanError($event,index){
          const panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test($event)
          if($event == ""){
            this.panError = '';
          }else if(panStr){
            this.isAddClass = true;
            this.panError = '';
          }
          else{
            this.isAddClassServerError = true;
            this.isAddClass = false;
            this.panError = 'Invalid PAN number.';
          }
        },
        removeMember(index){
          this.partAdata.splice(index, 1);  
        },
        showMore(){
          this.partAdata.push({})
          this.showHide(this.partAdata.length-1); 
        },

        showForm(index, e,member_list){
          if(index > 0 && this.partAdata[index].address !=''){
            this.partAdata[index].address  = this.partAdata['0'].address
          }
          let member_data = {}
          member_list.forEach(val=>{
          member_data = val
          if(e == member_data.id){          
          this.partAdata[index].dob = member_data.dob;
          let dob1 = this.partAdata[index].dob;
          this.partAdata[index].gender = member_data.gender;
          this.partAdata[index].pan_no = member_data.pan_no;
          this.ageFinding(dob1,index,'initialize');
          this.partAdata[index].age = this.age; 
           
          if(member_data.id == 0){
          let self = this;
          Auth.currentAuthenticatedUser({
            bypassCache: false
          })
          .then(user => {
            // this.cognitoDetails.member = 0;
            let g = user.attributes["custom:gender"].toUpperCase();
            this.cognitoDetails.gender = g;
            this.partAdata[index].gender = g;
            let dob1 = user.attributes["custom:birth"];
            this.cognitoDetails.dob = dob1;
            this.partAdata[index].dob = dob1;
            this.ageFinding(dob1,0,'initialize');
            this.cognitoDetails.age = this.age;
            this.partAdata[index].age = this.age; 
            let pan = user.attributes["custom:pancard"];
            this.cognitoDetails.pan_no = pan;
             this.partAdata[index].pan_no = pan;
          })}
         }
           })
          this.updateMemberList();
          
          this.$set(this.seen, index, !this.seen[index]);
          
        },
        showHide(index,member_list){ 
          this.updateMemberList();
          this.$set(this.seen, index, !this.seen[index]);
        },
          
        initialize() {
          let self = this;
          Auth.currentAuthenticatedUser({
            bypassCache: false
          })
          .then(user => {
            this.cognitoDetails.member = 0;
            let g = user.attributes["custom:gender"].toUpperCase();
            this.cognitoDetails.gender = g;
            // console.log( this.cognitoDetails.gender,' this.cognitoDetails.gender')
            let dob1 = user.attributes["custom:birth"];
            this.cognitoDetails.dob = dob1;
            // console.log(this.cognitoDetails.dob ,'this.cognitoDetails.pan ')
            this.ageFinding(dob1,0,'initialize');
            this.cognitoDetails.age = this.age;
            let pan = user.attributes["custom:pancard"];
            this.cognitoDetails.pan_no = pan;
            // console.log(this.cognitoDetails.pan_no ,'this.cognitoDetails.pan ')
             
            setTimeout(() => {
              // console.log(self.all_member_list[0].name,'')
              self.all_member_list[0].dob=self.cognitoDetails.dob
              self.all_member_list[0].pan_no=self.cognitoDetails.pan_no
              self.all_member_list[0].gender=user.attributes["custom:gender"].toUpperCase();
              self.all_member_list.forEach(function(item, index) {
                let dob= item.dob;
                // if (index > 0) {
                  self.partAdata.push({ member_list:self.all_member_list});    
                // }
                self.member_list.push(item);
              });
            }, 1000);
          });
        },

        ageFinding(e, index, type){
          let prefix = ''
          if(type == 'list'){
            prefix = 'more_'
          }
          let new_index = index + 1
          let formated_dob = moment(String(e)).format('DD MMM, yyyy')
          let DOB = new Date(formated_dob);  
          let today = new Date();
          let age = today.getFullYear() - DOB.getFullYear();
          if (type == 'initialize') {
            this.age = age;
          }
          else {
            let obj = this.partAdata[index];
            obj.age = age;
            this.$set(this.partAdata, index, obj);
          }
        },

        details() {
            this.$router.push({ name: 'MemberDetails' }).catch(() => {});
        },

        backButton1() {
            this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
        },

        backButton2() {
            this.$router.push({ name: 'MyWill' }).catch(() => {});
        },

        updateMemberList() {
          let selectedMembers = [];
          let self = this;
          this.partAdata.forEach(function(item, index) {
            // remove selected members from list..
            let members = [];
            self.member_list.forEach(member => {
              if(!selectedMembers.includes(member.id)){
                members.push(member)
              }
            })
            item.member_list = members;
            // collect selected members..
            if ('member' in item) {
              selectedMembers.push(item.member)
              // console.log(selectedMembers,'selectedMembers')
              if(item.member == 0){
                // console.log(item.member,'jjjjjjj')
                // self.initialize();
              }
            }
          });
        },

        fillMembersData(member_id,will_id){
          let self = this;
          this.partAdata = [];
          this.all_member_list.forEach(function(item, index) { 
            // if (index > 0) {    
              self.partAdata.push({member_list:self.all_member_list});
            // }
            self.member_list.push(item)
          });
          axios.post(
            process.env.VUE_APP_ROOT_API + "get-will-members",
            {
              aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
              will_id:will_id,
              member_id:member_id
            }
          )
          .then((response) => {
            if(response.data.data.length){
              console.log(response.data.data,'response.data.data')
              response.data.data.forEach((res, index) => {
                let obj = {};
                if (this.partAdata[index] !== undefined) {
                  obj = this.partAdata[index];
                }
                if (res.member_id === null) {
                  obj.member = res.name;
                }
                else {
                  obj.member = res.member_id;
                }
                obj.gender = res.gender.toUpperCase();
                obj.dob = res.dob;
                obj.age = res.age;
                obj.occupation = res.occupation;
                obj.marital_status = res.marital_status;
                obj.date_of_marriage = res.marriage_date;
                obj.religion = res.religion;
                obj.nationality = res.nationality;
                obj.address = res.address;
                obj.title   = res.title;
                obj.pan_no = res.pan_no;
                obj.residential_status = res.residential_status;
                obj.relation_type = res.relation_type;
                if (this.partAdata[index] !== undefined) {
                  this.$set(this.partAdata, index, obj);
                  this.updateMemberList();
                }
                else {
                  this.partAdata.push(obj)
                }
              })
            }
            else {
              if(!member_id){
                this.cognitoDetails.all_member_list = self.all_member_list;
                this.cognitoDetails.relation_type = 'Self';
                this.$set(this.partAdata, 0, this.cognitoDetails);
                this.updateMemberList();
              }
              else {
                axios.post(
                  process.env.VUE_APP_ROOT_API + "get-family-member-detail",
                  {
                    member_id:member_id,
                    aws_cognito_id:atob(localStorage.getItem('cognito_idp'))
                  }
                )
                .then((response) => {
                  let obj = this.partAdata[0];
                  let res = response.data.data;
                  obj.member = member_id;
                  let g = res.gender;
                  obj.gender = g.toUpperCase();
                  obj.dob = res.formatted_dob;
                  this.ageFinding(obj.dob,0,'initialize');
                  obj.age = this.age;
                  obj.pan_no = res.pan;
                  obj.relation_type = 'Self';
                  this.$set(this.partAdata, 0, obj);
                })
              }
            }
            // this.initialize();
          })
        },

        saveMemberDetails(item,index){
          // let nextIndex = index+1;
          // let address = document.getElementById('address'+nextIndex).value;
          // document.getElementById('address2').value = address
          let formdata = item;
          formdata.aws_cognito_id = atob(localStorage.getItem('cognito_idp'));
          formdata.will_id = this.will_id;
          formdata.member_id = item.member;
          formdata.index = index;
          axios.post(process.env.VUE_APP_ROOT_API + "save-member-details", formdata)
          .then((response) => {
            if(response.data.status == 'success'){
              this.$set(this.seen, index, !this.seen[index]);
              swal.fire({
                title:'Data Added',
                icon:'success'
              })
            }
            else {
              swal.fire({
                title:'Error!',
                text:response.data.error,
                icon:'error'
              });
            }
          })
        },

        removeClass(e){
          let element = document.getElementsByClassName("menuable__content__active");
          console.log('dd',element.classList);
  
        }
    },
  };
</script>	
<style scoped>
#religion1 .menuable__content__active{
   style: none !important;
}
</style>
